export const BUTTON_LABELS = {
  MOVE_ALL_RIGHT: '≫',
  MOVE_SELECTED_RIGHT: '>',
  MOVE_SELECTED_LEFT: '<',
  MOVE_ALL_LEFT: '≪',
};
